<template>
  <div v-if="maintenanceLocked" class="text-gp-orange flex items-center gap-1 text-sm">
    <font-awesome-icon :icon="faExclamationTriangle" />
    <span class="xl:inline" :class="{ hidden: !props.inPopup }">{{
      t("ngp/admin_bar/maintenance_lock/info", { duration: humanDurationToUnlock })
    }}</span>
  </div>
</template>

<script setup lang="ts">
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useMaintenanceStore } from "../../store/maintenance";

const maintenance = useMaintenanceStore();

const props = defineProps<{
  inPopup: boolean;
}>();

const { t } = useI18n();
const maintenanceLocked = computed(() => maintenance.maintenanceLocked);
const humanDurationToUnlock = computed(() => maintenance.humanDurationToUnlock);
</script>
